import React, { Component } from "react";
import "./Backdrop.css";

export default class Backdrop extends Component {
  render() {
    return (
      <div className="backdrop" onClick={this.props.click}>
        <div className="child">{this.props.children}</div>
      </div>
    );
  }
}
